// extracted by mini-css-extract-plugin
module.exports = {"offices-list":"OfficesList_offices-list__vyosl","offices-list__title":"OfficesList_offices-list__title__dk9tN"};